// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** English UI strings: note info, teams on folders and notes, private folders (PLAN.md P8-T11). Merged into the catalog by messages.en.ts. */
export const access = {
  "access.tab.info": "Info",
  "access.info.noNote": "Open a note to see its details.",
  "access.info.localOnly": "This vault is only on this device. Sync it to see who created and changed its notes.",
  "access.info.loading": "Loading details…",
  "access.info.notSynced": "This note has not synced yet.",
  "access.info.created": "Created",
  "access.info.modified": "Last changed",
  "access.info.by": "{when} by {who}",
  "access.info.someone": "someone",
  "access.info.unknownCreator": "{when}",
  "access.info.size": "Size",
  "access.info.versions": "Versions",
  "access.info.history": "Version history",
  "access.info.location": "Folder",
  "access.info.root": "Top of the vault",
  "access.info.sharedWith": "Who can open it",
  "access.info.manage": "Manage access…",
  "access.info.sharedByEmail": "Shared by email",
  "access.info.onlyYou": "Only you",

  "access.kind.owner": "Owner",
  "access.kind.admin": "Workspace owners and admins",
  "access.kind.team": "Team {name}",
  "access.kind.teamMembers.one": "{count} member",
  "access.kind.teamMembers.other": "{count} members",
  "access.kind.you": "{name} (you)",
  "access.level.read": "Can read",
  "access.level.comment": "Can comment",
  "access.level.write": "Can edit",
  "access.level.admin": "Can manage",
  "access.from.vault": "whole vault",
  "access.from.folder": "from {folder}",

  "access.private.badge": "Private",
  "access.private.inside": "Private to {name}. Nobody else can open it, workspace admins included.",
  "access.private.insideYou": "Private to you. Nobody else can open it, workspace admins included.",
  "access.restricted.badge": "Limited",
  "access.restricted.inside": "Limited to the teams and people below (set on {folder}).",

  "access.dialog.title": "Access to {name}",
  "access.dialog.private": "Make this folder private",
  "access.dialog.privateHelp": "Only you will be able to open it. Workspace admins see that it exists and can make it shared again, but cannot open it.",
  "access.dialog.makePrivate": "Make private",
  "access.dialog.unprivate": "Stop keeping private",
  "access.dialog.restrict": "Only selected teams and people",
  "access.dialog.restrictHelp": "Everyone else with access to the vault stops seeing it. Workspace owners and admins always can.",
  "access.dialog.restrictOn": "Limit access",
  "access.dialog.restrictOff": "Open to everyone with vault access",
  "access.dialog.inherited": "Limited by {folder}. Change it there.",
  "access.dialog.add": "Give access",
  "access.dialog.who": "Team or person",
  "access.dialog.choose": "Choose…",
  "access.dialog.teams": "Teams",
  "access.dialog.people": "People",
  "access.dialog.level": "Access",
  "access.dialog.remove": "Remove",
  "access.dialog.done": "Done",

  "access.settings.title": "Private and limited folders",
  "access.settings.intro": "Private folders open only for the member who made them; you can make them shared again but not open them. Limited folders open only for the teams and people given them.",
  "access.settings.unprivate": "Make shared again",
  "access.settings.unlimit": "Open to the vault",

  "access.tree.access": "Access…",
  "access.tree.makePrivate": "Make private",
  "access.tree.private": "Private folder",
  "access.tree.restricted": "Limited to some teams and people",

  "access.history.by": "by {who}",
} as const;
